import { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../ui/card";
import { Badge } from "../ui/badge";
import { getStudentUpcomingSignups } from "../../lib/api";

function fmt(iso) {
  try { return new Date(iso + "T00:00:00").toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" }); }
  catch { return iso; }
}

export default function StudentSignupsCard({ studentId }) {
  const [data, setData] = useState({ block_picks: [], trip_picks: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!studentId) return;
    getStudentUpcomingSignups(studentId)
      .then((r) => setData(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [studentId]);

  if (loading) return null;
  const blocks = data.block_picks || [];
  const trips = data.trip_picks || [];
  if (blocks.length === 0 && trips.length === 0) return null;

  // Group block picks by date for nicer display
  const byDate = {};
  blocks.forEach((p) => {
    (byDate[p.date] = byDate[p.date] || []).push(p);
  });
  const sortedDates = Object.keys(byDate).sort();

  return (
    <Card data-testid="student-signups-card">
      <CardHeader className="pb-3">
        <CardTitle className="text-base">Upcoming Sign-Ups</CardTitle>
        <CardDescription>{blocks.length} class pick{blocks.length === 1 ? "" : "s"} · {trips.length} trip{trips.length === 1 ? "" : "s"}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        {sortedDates.length > 0 && (
          <div className="space-y-2">
            {sortedDates.map((d) => (
              <div key={d} className="flex items-start gap-3 text-sm" data-testid={`student-signup-date-${d}`}>
                <div className="text-xs font-semibold text-muted-foreground w-24 shrink-0 pt-0.5">{fmt(d)}</div>
                <div className="flex flex-wrap gap-1.5">
                  {byDate[d].map((p) => (
                    <Badge key={p.id} variant="outline" className="bg-indigo-50 text-indigo-800 border-indigo-200">{p.option_title}</Badge>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
        {trips.length > 0 && (
          <div className="pt-2 border-t">
            <div className="text-xs font-semibold uppercase tracking-wide text-muted-foreground mb-1">Trips & Events</div>
            <div className="flex flex-wrap gap-1.5">
              {trips.map((p) => (
                <Badge key={p.id} className={p.response === "yes" ? "bg-green-100 text-green-800" : "bg-amber-100 text-amber-800"}>
                  {p.option_title} · {p.response?.toUpperCase()}
                </Badge>
              ))}
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
